if (!customElements.get('redefine-intro')) {
  customElements.define('redefine-intro', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
        let id;
        try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
        const target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        if (location.hash !== url.hash) history.pushState(null, '', url.hash);
      }, { signal: this.controller.signal });
      if (this.dataset.animate !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.classList.add('is-ready');
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          this.observer.unobserve(entry.target);
        }
      }, {rootMargin:'0px 0px -10% 0px'});
      this.querySelectorAll('[data-reveal]').forEach(el => this.observer.observe(el));
      this.addEventListener('focusin', event => {
        let el = event.target;
        while (el && el !== this) {
          if (el.hasAttribute('data-reveal')) el.classList.add('is-in');
          el = el.parentElement;
        }
      }, {signal:this.controller.signal});
      this.addEventListener('shopify:block:select', () => {
        this.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('is-in'));
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.classList.remove('is-ready');
      this.querySelectorAll('.is-in').forEach(el => el.classList.remove('is-in'));
    }
  });
}
